import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface FeriadoData {
  fecha: Date;
  nombre: string;
}

@Component({
  selector: 'app-editar-feriado-dialog',
  templateUrl: './editar-feriado-dialog.component.html',
  styleUrls: ['./editar-feriado-dialog.component.scss']
})
export class EditarFeriadoDialogComponent {
  selectedDate: Date;
  nombre: string;
  mensaje_error_descripcion: string = '';
  mensaje_error_fecha: string = '';

  constructor(
  public dialogRef: MatDialogRef<EditarFeriadoDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: FeriadoData
) {
  console.log('Fecha recibida:', data.fecha);

  const [year, month, day] = (typeof data.fecha === 'string'
    ? data.fecha
    : data.fecha.toISOString().split('T')[0]
  ).split('-').map(Number);

  this.selectedDate = new Date(year, month - 1, day);

  console.log('Fecha convertida:', this.selectedDate);

  this.nombre = data.nombre;
}


  cancelar(): void {
    this.dialogRef.close();
  }

  validateForm(): boolean {
    let valido = true;

    if (!this.nombre || this.nombre.trim().length === 0) {
      this.mensaje_error_descripcion = 'La descripción no puede estar vacía';
      valido = false;
    } else {
      this.mensaje_error_descripcion = '';
    }

    if (!this.selectedDate) {
      this.mensaje_error_fecha = 'Debe seleccionar una fecha';
      valido = false;
    } else {
      this.mensaje_error_fecha = '';
    }

    return valido;
}

  modificar(): void {
    const valido = this.validateForm();

    if (!valido) {
      return;
    }
    this.dialogRef.close({
      fecha: this.selectedDate,
      nombre: this.nombre
    });

  }

  
}
